import { all, takeLatest} from 'redux-saga/effects';
import {
  patchAccount,
  resendEmailConfirmation
} from 'utils/api';

import {
  PATCH_ACCOUNT_REQUEST,
  RESEND_EMAIL_CONFIRMATION
} from './constants';

import {
  putAccountFailure,
  putAccountSuccess,
  resendEmailConfirmationSuccess,
  resendEmailConfirmationFailure,
} from './actions'

import { authedApiSaga } from 'sagas';

export function* patchAccountFlow({ payload }) {
    yield* authedApiSaga(patchAccount, [{
      ...payload,
    }], putAccountSuccess, putAccountFailure);
}


export function* resendEmailConfirmationFlow() {
    yield* authedApiSaga(resendEmailConfirmation, [], resendEmailConfirmationSuccess,resendEmailConfirmationFailure);
}

export default function* watchAccount() {
  yield all([
    takeLatest(PATCH_ACCOUNT_REQUEST, patchAccountFlow),
    takeLatest(RESEND_EMAIL_CONFIRMATION, resendEmailConfirmationFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/containers/AccountPage/sagas.js